// -----------------------注意区分request2和request
import request2 from '@/utils/request2';
import request from '@/utils/request';
export function questionnaireList(data) {
  return request2.post('admin/questionnaire/list', data);
}

//问卷整体数据
export function detail(data) {
  return request2.post('/admin/questionnaire/detail', data);
}

//签名上传
export function cascadesign(data) {
  return request.post('/admin/flow-node-config/sign', data);
}

//问卷填写保存
export function questionnaireSave(data) {
  return request2.post('admin/questionnaire/store', data);
}
/**图片上传 */
export const uploadFile = process.env.VUE_APP_BASE_API + 'upload/file';